module.exports = __webpack_public_path__ + "static/logo-a17dd8348f41306ddf709a1db5ea24be.png";